var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPermission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 180,
    viewBox: "0 0 288 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1357_28065)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1357_28065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.78 63.4792C214.78 63.4792 208.012 10.5192 168.08 48.5951C116.89 97.4027 82.4809 0.396462 44.5068 39.9934C23.7608 61.6251 78.5819 110.004 41.9691 135.464C5.35639 160.924 35.2756 179.984 35.2756 179.984H243.172C243.172 179.984 264.694 181.538 266.323 154.305C267.95 127.072 242.932 126.742 258.459 92.6624C273.986 58.5828 219.659 85.1708 214.78 63.4792Z",
    fill: "#E3F2FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.06,
    y: 105.84,
    width: 15.12,
    height: 74.16,
    fill: "url(#paint0_linear_1357_28065)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.58,
    y: 138.24,
    width: 15.12,
    height: 41.76,
    fill: "url(#paint1_linear_1357_28065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.7 79.9204L197.38 68.4004L211.06 79.9204V180H183.7V79.9204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.02,
    y: 83.5205,
    width: 7.92,
    height: 19.44,
    fill: "#E3F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.02,
    y: 105.84,
    width: 7.92,
    height: 19.44,
    fill: "#E3F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.02,
    y: 128.16,
    width: 7.92,
    height: 19.44,
    fill: "#E3F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.82,
    y: 83.5205,
    width: 7.92,
    height: 19.44,
    fill: "#E3F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.82,
    y: 105.84,
    width: 7.92,
    height: 19.44,
    fill: "#E3F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.82,
    y: 128.16,
    width: 7.92,
    height: 19.44,
    fill: "#E3F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.02,
    y: 151.2,
    width: 18.72,
    height: 28.8,
    fill: "#E3F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.3799,
    y: 79.9199,
    width: 20.16,
    height: 100.08,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.9795,
    y: 74.1602,
    width: 12.96,
    height: 5.76,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1396 68.4002L99.4596 65.1602L103.78 68.4002V74.1602H95.1396V68.4002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.54 115.2L129.7 126.72V180H109.54V115.2Z",
    fill: "url(#paint2_linear_1357_28065)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1357_28065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.309 139.884C192.309 161.774 174.565 179.518 152.675 179.518C130.784 179.518 113.04 161.774 113.04 139.884C113.04 127.568 118.648 116.568 127.466 109.301C127.484 109.283 127.502 109.283 127.52 109.265C134.318 103.657 143.045 100.285 152.548 100.249H152.675C153.161 100.249 153.648 100.249 154.135 100.267C156.75 100.357 159.292 100.7 161.745 101.277C179.272 105.388 192.309 121.112 192.309 139.884Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.919 123.835C187.639 124.034 187.098 123.619 186.358 121.978C185.998 122.285 185.655 122.573 185.204 122.97C184.952 122.411 184.754 121.942 184.537 121.473C184.339 121.004 184.123 120.914 183.672 121.275C183.365 121.527 182.788 121.798 182.536 121.653C182.247 121.509 182.103 120.932 182.067 120.517C182.013 119.94 182.067 119.688 181.219 119.67C180.3 119.652 179.38 119.003 178.352 118.588C178.19 119.616 178.028 120.626 177.847 121.653C177.397 121.762 176.946 121.852 176.495 121.978C175.07 122.357 174.205 122.086 173.339 120.86C172.762 120.049 172.293 119.147 171.644 118.047C172.834 117.741 173.862 117.416 174.926 117.236C175.9 117.073 177.775 115.613 178.028 114.657C178.046 114.567 178.064 114.477 178.064 114.405C177.883 113.449 177.703 112.511 177.505 111.447C177.342 111.447 177 111.501 176.693 111.429C176.116 111.321 175.611 111.123 175.359 110.474C175.251 110.203 174.89 109.915 174.602 109.842C173.141 109.5 172.816 109.211 172.69 107.787C172.654 107.246 172.672 106.705 172.69 106.164C172.69 106.002 172.708 105.857 172.708 105.623C169.336 103.639 165.64 102.143 161.709 101.223C161.366 102.161 160.771 102.684 159.689 102.828C159.112 102.9 158.553 103.513 158.102 103.982C157.237 104.92 156.479 105.93 155.668 106.939C154.442 106.434 153.991 105.425 153.558 104.325C153.017 102.954 153.179 101.674 153.847 100.43C153.901 100.34 153.991 100.267 154.099 100.195C153.648 100.249 153.161 100.249 152.675 100.249H152.548C152.62 100.304 152.675 100.358 152.711 100.43C152.819 100.592 152.747 101.025 152.602 101.169C151.899 101.8 151.142 102.359 150.403 102.954C149.375 101.71 148.617 101.512 146.994 101.98C146.634 102.089 146.021 102.161 145.84 101.962C145.191 101.277 144.722 101.71 144.218 102.053C143.604 102.467 143.045 102.936 142.396 103.297C141.423 103.838 141.332 105.677 141.783 106.38C141.909 106.579 142.36 106.741 142.595 106.669C143.622 106.416 144.542 105.93 145.101 104.992C145.335 104.595 145.552 104.631 146.003 104.667C146.544 104.703 147.193 104.469 147.644 104.144C148.635 103.405 148.78 103.351 149.645 104.216C149.807 104.379 149.97 104.595 150.168 104.721C150.817 105.082 150.799 105.551 150.457 106.11C150.222 106.489 150.06 106.903 149.825 107.39C150.204 107.48 150.529 107.552 150.889 107.625C150.835 108.039 150.817 108.454 150.709 108.833C150.33 110.185 149.393 111.285 147.896 110.059C147.391 109.644 146.742 109.77 146.435 110.347C145.967 111.267 145.119 111.339 144.326 111.303C142.522 111.213 140.882 111.736 139.313 112.547C139.132 112.637 138.898 112.8 138.754 112.764C137.654 112.403 136.987 113.233 136.175 113.665C135.382 114.098 134.57 114.513 133.741 114.873C133.218 115.108 132.911 115.342 132.875 116.027C132.785 117.236 132.479 118.426 132.244 119.706C131.252 119.273 131.072 118.444 130.964 117.759C130.693 116.027 129.882 115.739 128.638 115.505C126.348 115.072 123.372 116.478 122.417 118.516C122.038 119.327 122.038 120.391 122.128 121.311C122.2 122.122 123.192 122.537 124.13 122.231C124.689 122.05 125.266 122.032 125.392 122.609C125.464 122.988 125.085 123.475 124.833 123.889C124.725 124.07 124.454 124.16 124.274 124.304C123.697 124.773 123.661 125.26 124.274 125.693C124.707 125.999 124.743 126.252 124.617 126.775C124.076 128.975 125.14 130.688 127.339 131.265C128.187 131.481 128.782 131.084 129.323 130.453C129.684 130.02 129.954 129.389 130.693 129.515C130.892 129.552 131.108 129.588 131.27 129.678C132.316 130.201 133.326 130.814 134.39 131.283C135.364 131.715 136.319 132.058 136.987 132.996C137.257 133.374 137.798 133.591 138.249 133.753C140.178 134.492 141.639 135.773 142.685 137.522C143.37 138.676 144.001 139.866 144.632 141.056C144.957 141.651 145.354 142.012 146.057 142.174C147.553 142.499 148.978 143.112 150.114 144.194C151.214 145.239 151.358 146.267 150.547 147.566C150.222 148.107 149.681 148.503 149.321 149.026C148.888 149.675 148.401 150.343 148.185 151.082C147.662 152.777 146.76 154.255 145.606 155.554C145.101 156.131 144.236 156.564 143.478 156.708C142.162 156.942 141.441 157.79 140.773 158.764C140.214 159.593 139.547 160.368 139.114 161.252C138.429 162.622 137.095 163.199 135.959 163.993C134.228 165.183 132.984 166.77 132.425 168.735C132.172 169.619 132.623 170.701 132.749 171.674C132.839 172.36 132.965 173.045 133.074 173.784C131.018 172.991 129.72 171.512 128.746 169.763C128.367 169.078 128.331 168.194 128.151 167.401C128.025 166.824 128.025 166.211 127.808 165.688C127.213 164.263 127.43 162.821 127.646 161.396C127.772 160.567 127.79 159.791 127.7 158.926C127.556 157.7 127.898 156.419 128.043 155.157C128.115 154.544 128.259 153.931 128.313 153.318C128.367 152.741 128.151 152.29 127.844 151.767C127.502 151.154 127.466 150.306 127.502 149.567C127.538 149.098 127.574 148.864 127.141 148.557C125.536 147.439 124.076 145.961 123.445 144.23C122.669 142.066 122.02 139.631 123.733 137.395C124.526 136.35 125.302 135.232 125.753 134.005C126.366 132.347 125.969 131.589 124.779 130.886C124.022 130.453 123.535 129.804 123.463 128.92C123.39 128.019 122.976 127.37 122.309 126.811C121.912 126.486 121.677 126.162 121.948 125.584C122.182 125.044 121.966 124.647 121.353 124.358C120.145 123.799 118.846 123.222 118.558 121.762C118.414 121.058 118.414 120.157 118.756 119.562C120.379 116.659 122.435 114.044 124.779 111.7C125.518 110.96 126.294 110.239 127.087 109.554C118.504 116.857 113.04 127.73 113.04 139.884C113.04 161.775 130.784 179.518 152.675 179.518C161.33 179.518 169.336 176.741 175.846 172.035L175.9 171.566C176.134 171.007 176.351 170.448 176.585 169.889C177.036 168.898 177.469 167.888 177.956 166.932C178.406 166.067 178.28 165.183 178.01 164.371C177.324 162.226 178.19 160.567 179.524 159.052C179.578 158.998 179.633 158.944 179.669 158.872C180.372 158.078 181.147 157.339 181.147 156.203C181.147 155.301 181.093 154.31 180.75 153.498C180.66 153.282 180.588 153.065 180.516 152.849C180.173 151.569 180.426 150.379 180.985 149.188C181.003 149.134 181.039 149.08 181.057 149.026C181.418 148.179 181.526 147.313 181.418 146.448C181.4 146.249 181.364 146.051 181.309 145.853C181.255 145.654 180.931 145.33 180.913 145.33C179.867 145.997 179.146 144.915 178.244 144.861C177.054 144.789 175.846 144.59 174.692 144.753C173.466 144.933 172.348 144.698 171.446 144.031C169.787 142.805 168.236 141.399 166.685 140.028C166.397 139.776 166.253 139.253 166.199 138.856C166.018 136.963 166.505 135.16 166.992 133.356C167.299 132.238 167.479 131.174 167.317 129.966C167.172 128.776 168.11 127.911 169.03 127.225C169.372 126.973 169.841 126.865 170.22 126.648C170.616 126.414 171.121 126.216 171.356 125.855C172.78 123.691 174.998 123.403 177.252 123.439C179.019 123.475 180.841 123.565 182.518 124.034C183.708 124.358 184.772 125.26 185.781 126.035C186.647 126.684 187.476 127.171 188.612 127.045C189.135 126.991 189.676 127.117 190.199 127.189C189.839 126.035 189.406 124.917 188.919 123.835ZM129.053 122.555C129.305 121.527 130.225 121.058 130.892 121.563C131.757 122.212 132.695 122.483 133.759 122.519C134.011 122.537 134.246 122.699 134.498 122.808C134.462 122.934 134.444 123.042 134.408 123.168C132.623 122.952 130.856 122.753 129.053 122.555ZM136.626 125.783C135.49 125.675 134.426 125.566 133.272 125.458C134.408 124.575 135.526 124.034 136.842 125.26C136.77 125.44 136.68 125.657 136.626 125.783ZM162.159 105.713C162.015 106.074 161.835 106.669 161.582 106.723C161.132 106.813 160.609 106.615 160.158 106.416C159.707 106.236 159.328 105.911 158.914 105.641C158.95 105.533 159.004 105.407 159.04 105.298C159.797 105.01 160.555 104.667 161.33 104.469C161.618 104.397 162.069 104.613 162.322 104.848C162.43 104.992 162.268 105.443 162.159 105.713ZM170.472 112.439C170.31 112.133 170.184 111.844 170.021 111.537C170.761 111.213 171.085 110.708 170.869 109.897C170.851 109.824 171.446 109.482 171.5 109.536C172.618 110.582 174.061 111.267 174.638 112.908C174.926 113.719 174.547 113.972 174.133 114.296C173.231 114.982 172.221 114.603 171.987 113.521C171.879 113.07 171.825 112.601 171.734 112.006C171.266 112.151 170.887 112.277 170.472 112.439Z",
    fill: "#2D87F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.641,
    y: 92.1611,
    width: 36.72,
    height: 32.4,
    fill: "#FEA21E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.044 106.09C155.443 105.506 156.427 104.125 156.427 102.514C156.427 100.375 154.693 98.6406 152.554 98.6406C150.415 98.6406 148.681 100.375 148.681 102.514C148.681 104.125 149.665 105.506 151.064 106.09V114.431C151.064 115.253 151.731 115.92 152.554 115.92C153.377 115.92 154.044 115.253 154.044 114.431V106.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.121 84.6007C141.121 78.0396 146.44 72.7207 153.001 72.7207V72.7207C159.562 72.7207 164.881 78.0396 164.881 84.6007V92.1607H141.121V84.6007Z",
    fill: "#2D87F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.521 83.521C146.521 79.9422 149.422 77.041 153.001 77.041V77.041C156.579 77.041 159.481 79.9422 159.481 83.521V92.161H146.521V83.521Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1357_28065",
    x: 100.8,
    y: 85.849,
    width: 113.829,
    height: 113.829,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.04,
    dy: 2.88
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.64
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.721569 0 0 0 0 0.792157 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1357_28065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1357_28065",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1357_28065",
    x1: 199.682,
    y1: 83.2387,
    x2: 239.786,
    y2: 84.2861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1357_28065",
    x1: 157.202,
    y1: 125.513,
    x2: 197.248,
    y2: 127.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1357_28065",
    x1: 94.3695,
    y1: 95.4516,
    x2: 147.794,
    y2: 97.5808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1357_28065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 180,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1357_28065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 242.863,
    height: 149.835,
    fill: "white",
    transform: "translate(23.7598 30.2402)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/Permission.09c6eb4759e24d0591d47bfa5ea4b24b.svg";
export { ForwardRef as ReactComponent };